import {connect} from 'react-redux'

import {ViewDestination} from './view_destination.component'

import {appendDay} from '../../planner/planner.action'
import legUtil from '../../util/leg.util'
import userUtil from '../../util/user.util'

import {addLegDestinationAndAccom, addDestinationAndAccom, addLegDestinationAndActivity, addDestinationAndActivity} from '../../leg/leg.action'

const mapStateToProps = (state) => {
    return {
        leg: legUtil.getActiveLeg(state),
        lastLeg: legUtil.getLastLeg(state),
        totalDays: state.getIn(['document', 'properties', 'totalDays']) || 1,
        currentUser: userUtil.getCurrentUser(state),
        lunaTrip: state.get('lunaTrip')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddDayLegDestinationAndAccom: (startDay, destination, accom, user) => {
            dispatch(appendDay())
            dispatch(addLegDestinationAndAccom(startDay, destination, accom, user))
        },
        onAddLegDestinationAndAccom: (startDay, destination, accom, user) => {      
            dispatch(addLegDestinationAndAccom(startDay, destination, accom, user))
        },
        onAddDestinationAndAccom: (leg, destination, accom, user) => {     
            dispatch(addDestinationAndAccom(leg, destination, accom, user))
        },
        onAddDayLegDestinationAndActivity: (startDay, destination, act, user) => {
            dispatch(appendDay())
            dispatch(addLegDestinationAndActivity(startDay, destination, act, user))
        },
        onAddLegDestinationAndActivity: (startDay, destination, act, user) => {
            dispatch(addLegDestinationAndActivity(startDay, destination, act, user))
        },
        onAddDestinationAndActivity: (leg, destination, act, user) => {
            dispatch(addDestinationAndActivity(leg, destination, act, user))
        }
    }
}

const ViewDestinationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewDestination)

export default ViewDestinationContainer